import { default as emotionStyled } from '@emotion/styled'
import { MediaQueries, ScrollList, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledBabyPoopDetail = styled.div`
  .inline-button {
    display: flex;
    margin-top: 16px;
    gap: 8px;
    justify-content: center;
    .grow {
      width: 100%;
      flex-grow: 1;
    }
    .share span {
      display: flex;
      align-items: center;
    }
  }
`

export const StyledBabyPoopDetailImageWrapper = emotionStyled.div`
  position: relative;
  overflow: hidden;
  height: 380px;
  border-radius: ${(props) => props.theme.radius.lg}px
`

export const StyledBabyPoopDetailPoopImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 300ms;
  filter: blur(0);

  [data-is-blurred='true'] & {
    filter: blur(12px);
  }
`

export const StyledBabyPoopDetailImageFloatContent = styled.div`
  position: absolute;
  gap: 12px;
  display: flex;

  bottom: 50%;
  left: 48px;
  right: 48px;
  transform: translateY(50%);

  &,
  * {
    transition: all 300ms;
  }

  svg {
    flex-shrink: 0;
  }

  * {
    opacity: 1;
    transform: scale(1);
    transform-origin: bottom left;
  }

  [data-is-blurred='false'] & {
    bottom: 12px;
    left: 0px;
    transform: translateY(0);

    svg {
      width: 0;
    }

    svg,
    p {
      opacity: 0;
      transform: scale(0);
    }
  }
`

export const StyledBabyPoopDetailMainColumn = styled.div`
  padding-bottom: 40px;
`

export const StyledBabyPoopDetailVideoList = styled(ScrollList)`
  position: relative;

  svg.chevron {
    border-radius: 50%;
    outline: 1px solid ${(props: ThemeProps) => props.theme?.colors.neutral200};
    background-color: ${(props: ThemeProps) => props.theme?.colors.white};
    position: absolute;
    top: 80px;

    &.left {
      left: 0;
    }

    &.right {
      right: 0;
    }
  }
`

export const StyledBabyPoopDetailVideo = styled.div`
  width: 180px;
  flex-shrink: 0;

  iframe {
    width: 100%;
    height: 160px;
  }
`

export const StyledBabyPoopDetailBackButton = styled.a`
  display: block;
  width: fit-content;
  margin: auto;
  text-decoration: none;
`

export const StyledActions = emotionStyled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
`
export const StyledDisclamerInfo = emotionStyled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
export const StyledContent = emotionStyled.div``
export const StyledBody = emotionStyled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`
export const StyledMobileShare = emotionStyled.div`
display: flex;
gap: 10px;
`

export const StyledBreadCrumbsContainer = styled.div`
  background-color: #fff;

  .breadcrumbs {
    padding: 24px 16px;
  }

  ${MediaQueries.mbDown} {
    > div {
      background-color: #fff;
      border-radius: 16px 16px 0 0;
    }
    .breadcrumbs {
      padding: 16px 0;
      border-bottom: 1px solid
        ${(props: ThemeProps) => props.theme.mbColors.lightGray};
    }
  }
`
